import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { Toast } from "primereact/toast";
import "primeflex/primeflex.css";

import {
  OilIntakeLogModel,
  VendorResponse,
} from "../../models/oilProduction-model";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { useNavigate } from "react-router-dom";

interface Option {
  label: string;
  value: number;
}
interface DropdownOption {
  label: string;
  value: number;
}

interface OilseedOption {
  label: string;
  value: number;
}

interface VendorOption {
  label: string;
  value: number;
}

interface InvoiceOption {
  label: string;
  invoiceNumber: string;
  value: number;
  quantityLeft: number;
}

interface Invoice {
  id: number;
  rawMaterialPurchaseID: number;
  invoiceID: string;
  quantityLeft: number;
}

interface Props {
  data?: OilIntakeLogModel[];
  setLoading: (loading: boolean) => void;
}
interface InvoiceOption {
  label: string;
  value: number;
  quantityLeft: number;
}

const OilProductionDataTable1: React.FC<Props> = ({ data, setLoading }) => {
  const [records, setRecords] = useState<OilIntakeLogModel[]>([]);

  const [showDialog, setShowDialog] = useState(false);
  const [startTime, setStartTime] = useState<Date>(new Date());
  const [endTime, setEndTime] = useState<Date>(new Date());
  const [selectedOperator1, setSelectedOperator1] = useState<number | null>(
    null
  );
  const [selectedOperator2, setSelectedOperator2] = useState<number | null>(
    null
  );
  const [selectedBull1, setSelectedBull1] = useState<number | null>(null);
  const [selectedBull2, setSelectedBull2] = useState<number | null>(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<OilIntakeLogModel | null>(
    null
  );
  const [gaanaNumber, setGaanaNumber] = useState<number | null>(null);
  const [gaanaOptions, setGaanaOptions] = useState<Option[]>([]);
  const [oilseedWeight, setOilseedWeight] = useState<number | null>(null);
  const [moistureContent, setMoistureContent] = useState<number | null>(null);
  const [emptyContainerWeight, setEmptyContainerWeight] = useState<
    number | null
  >(null);
  const [vendors, setVendors] = useState<DropdownOption[]>([]);
  const [vendorInvoices, setVendorInvoices] = useState<VendorResponse[]>([]);
  const [operators, setOperators] = useState<Option[]>([]);
  const [bulls, setBulls] = useState<Option[]>([]);
  const toast = useRef<Toast>(null);
  const [manufactureId, setManufactureId] = useState<number | null>(null);

  const [oilseedOptions, setOilseedOptions] = useState<
    { label: string; value: number }[]
  >([]);

  const [oilseed, setOilseed] = useState<{ label: string; value: any } | null>(
    null
  );

  const [oilseeds, setOilseeds] = useState<OilseedOption[]>([]);
  const [vendorOptions, setVendorOptions] = useState<VendorOption[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<number | null>(null);

  const [invoiceOptions, setInvoiceOptions] = useState<InvoiceOption[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<InvoiceOption | null>(
    null
  );
  const navigate = useNavigate();
  const isEditMode = !!selectedRow;

  useEffect(() => {
    if (data !== undefined) {
      // Use provided data (can be empty array)
      setRecords(data);
    } else {
      // Fetch all logs from API if no data passed
      fetchAllLogs();
    }
  }, [data]);

  const fetchAllLogs = async () => {
    setLoading(true);
    try {
      const response = await oilProductionService.getAllOilIntakeLogs();
      const sorted = [...response].sort((a, b) => Number(b.id) - Number(a.id));
      console.log(
        "Before sorting:",
        response.map((r: { id: any }) => r.id)
      );
      console.log(
        "After sorting:",
        sorted.map((r) => r.id)
      );

      // const sorted = [...response].sort((a, b) => b.id - a.id); // copy first
      // console.log("Sorted Records:", sorted.map(r => r.id)); // debug
      setRecords(sorted);
    } catch (error) {
      console.error("Failed to fetch logs", error);
    } finally {
      setLoading(false);
    }
  };
  const handleStartClick = async (row: OilIntakeLogModel) => {
    setSelectedRow(row);
    setShowDialog(true);

    if (row.posID) {
      try {
        const plantResponse = await oilProductionService.GetMUPlantNameById(
          row.posID
        );
        if (plantResponse) setManufactureId(plantResponse.posID);
        const membersResponse = await oilProductionService.getBullsAndOperators(
          row.posID
        );
        if (membersResponse) {
          setOperators(
            membersResponse.operators.map((op: any) => ({
              label: op.name,
              value: op.id,
            }))
          );
          setBulls(
            membersResponse.bulls.map((b: any) => ({
              label: b.name,
              value: b.id,
            }))
          );
          setGaanaOptions(
            (membersResponse.gaanaDetails || []).map((g: any) => ({
              label: g.gaanaNumber,
              value: g.id,
            }))
          );
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  const showMessage = (
    summary: string,
    detail: string,
    severity: "success" | "error" | "warn" | "info"
  ) => {
    toast.current?.show({
      severity,
      summary,
      detail,
      life: 3000,
    });
  };
  const validateForm = (): boolean => {
    if (!startTime || !endTime) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Start and end time are required",
        life: 3000,
      });
      return false;
    }
    if (!gaanaNumber) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Select Gaana Number",
        life: 3000,
      });
      return false;
    }
    if (!oilseed) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select an oilseed",
        life: 3000,
      });
      return false;
    }
    if (!selectedVendor) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select a vendor",
        life: 3000,
      });
      return false;
    }
    if (!selectedInvoice) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select an invoice",
        life: 3000,
      });
      return false;
    }

    if (!oilseedWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Oil Seed Weight",
        life: 3000,
      });
      return false;
    }

    if (
      selectedInvoice?.quantityLeft &&
      oilseedWeight > selectedInvoice.quantityLeft
    ) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: `Entered weight exceeds available quantity (${selectedInvoice.quantityLeft} kg)`,
        life: 3000,
      });
      return false;
    }

    if (!moistureContent) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Moisture Content",
        life: 3000,
      });
      return false;
    }

    if (!emptyContainerWeight) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please Enter Empty Container Weight",
        life: 3000,
      });
      return false;
    }

    return true;
  };
  const validateStartForm = () => {
    if (!startTime) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Start time required",
      });
      return false;
    }
    if (!selectedOperator1) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Select Operator 1",
      });
      return false;
    }
    if (!selectedBull1) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Select Bull 1",
      });
      return false;
    }
    return true;
  };

  // Effect: Prefill on page load in edit mode
  useEffect(() => {
    const prefillData = async () => {
      if (!selectedRow || !isEditMode) return;

      try {
        const { oilSeedID, vendorID, rawMaterialPurchaseID, posID } =
          selectedRow;

        if (oilSeedID) {
          setOilseed(oilSeedID);

          // fetch vendors for that oilseed
          const vendorResponse = await oilProductionService.getVendorsByOilseed(
            oilSeedID,
            posID ?? undefined
          );

          setVendorInvoices(vendorResponse);
          const formattedVendors = vendorResponse.map((vendor: any) => ({
            label: vendor.firmInfo,
            value: vendor.vendorID,
          }));
          setVendors(formattedVendors);

          // preselect vendor
          setSelectedVendor(vendorID);

          // find invoices for that vendor
          const vendor = vendorResponse.find(
            (v: any) => v.vendorID === vendorID
          );
          if (vendor?.invoices) {
            const formattedInvoices = vendor.invoices.map((inv: any) => ({
              label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
              value: inv.rawMaterialPurchaseID, // ⚡ use rawMaterialPurchaseID
              quantityLeft: inv.quantityLeft,
              invoiceNumber: String(inv.invoiceID),
            }));
            setInvoiceOptions(formattedInvoices);

            // preselect invoice
            const invoiceMatch = formattedInvoices.find(
              (inv: any) => inv.value === rawMaterialPurchaseID
            );
            setSelectedInvoice(invoiceMatch || null);
          }
        }
      } catch (error) {
        console.error("Error during prefill:", error);
      }
    };

    prefillData();
  }, [isEditMode, selectedRow]);

  // Effect: When oilseed changes manually
  // useEffect(() => {
  //   if (!oilseed || isEditMode) return; // 🚨 skip reset if it's prefill

  //   const fetchVendors = async () => {
  //     try {
  //       const vendorResponse = await oilProductionService.getVendorsByOilseed(
  //         oilSeedID,
  //         posID ?? undefined
  //       );

  //       setVendorInvoices(vendorResponse);
  //       setVendors(
  //         vendorResponse.map((vendor: any) => ({
  //           label: vendor.firmInfo,
  //           value: vendor.vendorID,
  //         }))
  //       );
  //       setSelectedVendor(null); // reset vendor
  //       setInvoiceOptions([]); // reset invoices
  //       setSelectedInvoice(null); // reset invoice
  //     } catch (error) {
  //       console.error("Error fetching vendors:", error);
  //     }
  //   };

  //   fetchVendors();
  // }, [oilseed]);

  const handleStartSave = async () => {
    if (!selectedRow || !validateStartForm()) return;

    const payload = {
      id: selectedRow.id,
      startTime: startTime.toTimeString().split(" ")[0],
      operator1ID: selectedOperator1 ?? null,
      operator2ID: selectedOperator2 ?? null,
      bull1ID: selectedBull1 ?? null,
      bull2ID: selectedBull2 ?? null,
    };
    console.log(payload);
    try {
      await oilProductionService.updateOilIntakeLog(selectedRow.id, payload);
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Oil Intake Log updated",
      });
      navigate("/oildatatable2");
      setShowDialog(false);
      resetStartDialog();
      fetchAllLogs();
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update",
      });
    }
  };

  const resetStartDialog = () => {
    setSelectedRow(null);
    setSelectedOperator1(null);
    setSelectedOperator2(null);
    setSelectedBull1(null);
    setSelectedBull2(null);
    setStartTime(new Date());
  };

  useEffect(() => {
    const prefillData = async () => {
      // if (!selectedRow) return;
      if (!selectedRow || !isEditMode) return;

      try {
        const { oilSeedID, invoiceID } = selectedRow;

        // 1. Prefill Oilseed (handle null safely)
        if (oilSeedID !== null) {
          setOilseed(oilSeedID);
          const vendorResponse = await oilProductionService.getVendorsByOilseed(
            oilSeedID,
            selectedRow.posID
          );

          setVendorInvoices(vendorResponse);
          const formattedVendors = vendorResponse.map((vendor: any) => ({
            label: vendor.firmInfo,
            value: vendor.vendorID,
          }));
          setVendors(formattedVendors);

          // 3. Prefill Vendor
          setSelectedVendor(selectedRow.vendorID);

          // 4. Load Invoices for selected Vendor
          const vendor = vendorResponse.find(
            (v) => v.vendorID === selectedRow.vendorID
          );
          if (vendor && vendor.invoices) {
            const formattedInvoices = vendor.invoices.map((inv: any) => ({
              label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
              value: inv.id,
              quantityLeft: inv.quantityLeft,
              invoiceNumber: String(inv.invoiceID),
              rawMaterialPurchaseID: inv.rawMaterialPurchaseID,
            }));
            setInvoiceOptions(formattedInvoices);
            // 5. Prefill Invoice
            const invoiceMatch = formattedInvoices.find(
              (inv: any) => inv.value === selectedRow.invoiceID
            );
            setSelectedInvoice(invoiceMatch || null);
          }
          //           debugger
          //           const invoiceMatch = formattedInvoices.find(
          //   (inv:any) => inv.value === selectedRow.rawMaterialPurchaseID
          // );
          // setSelectedInvoice(invoiceMatch || null);
          //           }
        }
      } catch (error) {
        console.error("Error during prefill:", error);
      }
    };

    if (isEditMode) prefillData();
  }, [selectedRow, isEditMode]);

  const handleEditClick = async (row: OilIntakeLogModel) => {
    setSelectedRow(row);
    setShowEditDialog(true);
    setGaanaNumber(row.gaanaID ?? null);

    try {
      // 1️Fetch Operators, Bulls, Gaana
      const membersResponse = await oilProductionService.getBullsAndOperators(
        row.posID
      );
      if (membersResponse) {
        const gaanaList: Option[] = (membersResponse.gaanaDetails || []).map(
          (g: any) => ({
            label: String(g.gaanaNumber),
            value: g.id,
          })
        );
        setGaanaOptions(gaanaList);

        setOperators(
          membersResponse.operators.map((op: any) => ({
            label: op.name,
            value: op.id,
          }))
        );
        setBulls(
          membersResponse.bulls.map((b: any) => ({
            label: b.name,
            value: b.id,
          }))
        );
      }
      // 2️ Fetch Oilseed options
      const oilseedResponse = await oilProductionService.getOilSeedNames(
        row.posID
      );
      const oilseedList: OilseedOption[] = (oilseedResponse || []).map(
        (o: any) => {
          const availableKg = o.availableQty || 0; // or the correct field from response
          return {
            label: `${o.rawMaterialName || o.oilSeedName || "Unknown"
              } (${availableKg} kg)`,
            value: o.rawMaterialID || o.oilSeedID || 0,
          };
        }
      );

      setOilseedOptions(oilseedList);

      // Prefill selected oilseed
      const oilseedMatch =
        oilseedList.find((o) => o.value === row.oilSeedID) || null;
      setOilseed(oilseedMatch || null);

      // 3️ Fetch Vendors for selected Oilseed
      if (row.oilSeedID) {
        const vendorsResponse: VendorResponse[] =
          await oilProductionService.getVendorsByOilseed(
            row.oilSeedID,
            row.posID
          );

        setVendorInvoices(vendorsResponse);

        const formattedVendors: VendorOption[] = vendorsResponse.map((v) => ({
          label: v.firmInfo,
          value: v.vendorID,
        }));
        setVendorOptions(formattedVendors);
        const vendorMatch = formattedVendors.find(
          (v) => v.value === row.vendorID
        );
        setSelectedVendor(vendorMatch ? vendorMatch.value : null);
        // 4️ Fetch Invoices for selected Vendor
        const vendorObj = vendorsResponse.find(
          (v) => v.vendorID === row.vendorID
        );
        if (vendorObj?.invoices) {
          const formattedInvoices: InvoiceOption[] = vendorObj.invoices.map(
            (inv) => ({
              label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
              value: inv.id,
              invoiceNumber: String(inv.invoiceID),
              quantityLeft: inv.quantityLeft,
              rawMaterialPurchaseID: inv.rawMaterialPurchaseID,
            })
          );
          setInvoiceOptions(formattedInvoices);
          // Prefill selected Invoice
          const invoiceMatch = formattedInvoices.find(
            (inv) => inv.invoiceNumber === String(row.invoiceNumber)
          );
          setSelectedInvoice(invoiceMatch || null);
        }
      }

      // 5️ Prefill remaining fields
      setOilseedWeight(row.oilSeedWeight ?? null);
      setMoistureContent(row.moistureContent ?? null);
      setEmptyContainerWeight(row.emptyContainerWeightKG ?? null);
    } catch (error) {
      console.error("Error in handleEditClick:", error);
    }
  };

  const handleEditSave = async () => {
    if (!selectedRow) return;

    const isValid = validateForm();
    if (!isValid) return;
    const payload = {
      id: selectedRow.id,
      gaanaID: gaanaNumber ?? null,
      oilSeedID: oilseed?.value ?? null,
      vendorID: selectedVendor ?? null,
      rawMaterialPurchaseID: selectedInvoice?.value ?? null,
      oilSeedWeight: oilseedWeight ?? null,
      moistureContent: moistureContent ?? null,
      EmptyContainerWeightKG: emptyContainerWeight ?? null,
      SubmittedDate: new Date().toISOString(),
    };

    try {
      await oilProductionService.updateOilIntakeLog1(selectedRow.id, payload);
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Record updated successfully",
      });
      setShowEditDialog(false);
      fetchAllLogs();
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update record",
      });
    }
  };
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const actionTemplateStart = (row: OilIntakeLogModel) => (
    <Button
      label="Start"
      className="p-button-success"
      onClick={() => handleStartClick(row)}
    />
  );
  const fieldHoverStyle = (fieldName: string) => ({
    border:
      hoveredField === fieldName ? "2px solid #6366F1" : "1px solid #ced4da",

    boxShadow:
      hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
  });
  const actionTemplateEdit = (row: OilIntakeLogModel) => (
    <Button
      label="Edit"
      className="p-button-warning"
      onClick={() => handleEditClick(row)}
    />
  );

  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <DataTable
          value={records}
          emptyMessage="No records found"
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          <Column field="oilSeedName" sortable header="Oilseed" />
          <Column field="oilSeedWeight" sortable header="Seed Weight (kg)" />
          <Column field="moistureContent" sortable header="Moisture (%)" />
          <Column field="gaanaName" sortable header="Gaana Used" />
          <Column header="Action" body={actionTemplateStart} />
          <Column header="Edit" body={actionTemplateEdit} />
        </DataTable>
      </div>

      {/* Start Dialog */}
      <Dialog
        visible={showDialog}
        modal
        style={{ width: "50vw" }}
        onHide={() => setShowDialog(false)}
        footer={
          <>
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => setShowDialog(false)}
            />
            <Button
              label="Save"
              className="p-button-primary"
              onClick={handleStartSave}
            />
          </>
        }
      >
        <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
          Start Oil Production
        </h5>
        <div className="p-grid">
          <div className="col-12 mb-2">
            <div className="grid">
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Operator 1<span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedOperator1}
                  options={operators.filter(
                    (op) => op.value !== selectedOperator2
                  )}
                  onChange={(e) => setSelectedOperator1(e.value)}
                  placeholder="Select Operator 1"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">Operator 2</label>
                <Dropdown
                  value={selectedOperator2}
                  options={operators.filter(
                    (op) => op.value !== selectedOperator1
                  )}
                  onChange={(e) => setSelectedOperator2(e.value)}
                  placeholder="Select Operator 2"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>

              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Bull 1<span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedBull1}
                  options={bulls.filter((b) => b.value !== selectedBull2)}
                  onChange={(e) => setSelectedBull1(e.value)}
                  placeholder="Select Bull 1"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">Bull 2</label>
                <Dropdown
                  value={selectedBull2}
                  options={bulls.filter((b) => b.value !== selectedBull1)}
                  onChange={(e) => setSelectedBull2(e.value)}
                  placeholder="Select Bull 2"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Start Time<span className="required">*</span>
                </label>
                <Calendar
                  value={startTime}
                  onChange={(e) => {
                    const dt = e.value as Date;
                    setStartTime(dt);

                    setEndTime(new Date(dt.getTime() + 2 * 60 * 60 * 1000));
                  }}
                  timeOnly
                  hourFormat="12"
                  stepMinute={15}
                  style={fieldHoverStyle("description")}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog
        visible={showEditDialog}
        modal
        style={{ width: "60vw" }}
        onHide={() => setShowEditDialog(false)}
        footer={
          <>
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => setShowEditDialog(false)}
            />
            <Button
              label="Save"
              className="p-button-primary"
              onClick={handleEditSave}
            />
          </>
        }
      >
        <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
          Edit Oil Intake Details
        </h5>
        <div className="p-grid">
          <div className="col-12 mb-2">
            <div className="grid">
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Gaana Number<span className="required">*</span>
                </label>
                <Dropdown
                  value={gaanaNumber}
                  options={gaanaOptions}
                  onChange={(e) => setGaanaNumber(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select Gaana Number"
                  style={fieldHoverStyle("description")}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Oilseed<span className="required">*</span>
                </label>
                <Dropdown
                  value={oilseed?.value ?? null}
                  options={oilseedOptions}
                  // onChange={async (e) => {
                  //   const selectedOilseed = e.value;
                  //   setOilseed(selectedOilseed);
                  //   if (!selectedOilseed) {
                  //     setVendors([]);
                  //     setVendorInvoices([]);
                  //     setSelectedVendor(null);
                  //     setInvoiceOptions([]);
                  //     setSelectedInvoice(null);
                  //     return;
                  //   }

                  //   try {
                  //     const response: VendorResponse[] =
                  //       await oilProductionService.getVendorsByOilseed(
                  //         selectedOilseed.value
                  //       );
                  //     const formattedVendors: DropdownOption[] = response.map(
                  //       (vendor) => ({
                  //         label: vendor.firmInfo,
                  //         value: vendor.vendorID,
                  //       })
                  //     );
                  //     setVendors(formattedVendors);
                  //     setVendorInvoices(response);
                  //     setSelectedVendor(null);
                  //     setInvoiceOptions([]);
                  //     setSelectedInvoice(null);
                  //   } catch (err) {
                  //     console.error("Error fetching vendors:", err);
                  //   }
                  // }}
                  onChange={async (e) => {
                    const selectedOilseedId = e.value; // number only
                    const selectedOilseedObj =
                      oilseedOptions.find(
                        (o) => o.value === selectedOilseedId
                      ) || null;

                    setOilseed(selectedOilseedObj);

                    if (!selectedOilseedId) {
                      setVendorOptions([]);
                      setVendors([]);
                      setVendorInvoices([]);
                      setSelectedVendor(null);
                      setInvoiceOptions([]);
                      setSelectedInvoice(null);
                      return;
                    }

                    try {
                      const response: VendorResponse[] =
                        await oilProductionService.getVendorsByOilseed(
                          selectedOilseedId,
                          selectedRow?.posID // pass posID too if required
                        );

                      const formattedVendors: DropdownOption[] = response.map(
                        (vendor) => ({
                          label: vendor.firmInfo,
                          value: vendor.vendorID,
                        })
                      );
                      setVendorOptions(formattedVendors);
                      setVendors(formattedVendors);
                      setVendorInvoices(response);
                      setSelectedVendor(null);
                      setInvoiceOptions([]);
                      setSelectedInvoice(null);
                    } catch (err) {
                      console.error("Error fetching vendors:", err);
                    }
                  }}
                  placeholder="Select Oilseed Name"
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                  className="w-full"
                />{" "}
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Vendor<span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedVendor}
                  options={vendorOptions}
                  onChange={(e) => {
                    const selectedVendorId = e.value;
                    setSelectedVendor(selectedVendorId);

                    const vendor = vendorInvoices.find(
                      (v) => v.vendorID === selectedVendorId
                    );
                    if (vendor && vendor.invoices) {
                      const formattedInvoices: InvoiceOption[] =
                        vendor.invoices.map((inv) => ({
                          label: `${inv.invoiceID} - ${inv.quantityLeft} kg`,
                          value: inv.id,
                          invoiceNumber: String(inv.invoiceID),
                          quantityLeft: inv.quantityLeft,
                          rawMaterialPurchaseID: inv.rawMaterialPurchaseID,
                        }));

                      setInvoiceOptions(formattedInvoices);
                      setSelectedInvoice(null);
                    }
                  }}
                  placeholder="Select Vendor Name"
                  style={fieldHoverStyle("description")}
                  className="w-full"
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Invoice<span className="required">*</span>
                </label>
                <Dropdown
                  value={selectedInvoice?.value || null}
                  options={invoiceOptions}
                  onChange={(e) => {
                    const selected = invoiceOptions.find(
                      (inv) => inv.value === e.value
                    );
                    setSelectedInvoice(selected || null);
                  }}
                  optionLabel="label"
                  placeholder="Select Vendor Invoice Number"
                  style={fieldHoverStyle("description")}
                  className="w-full"
                />{" "}
              </div>
              <div className=" col-12 md:col-6">
                <label className="label-semi-bold">
                  Oilseed Weight (kg)<span className="required">*</span>
                </label>
                <InputNumber
                  value={oilseedWeight}
                  onChange={(e) => {
                    const enteredWeight = e.value ?? 0;

                    if (
                      selectedInvoice?.quantityLeft &&
                      enteredWeight > selectedInvoice.quantityLeft
                    ) {
                      showMessage(
                        "Validation Error",
                        `Weight cannot exceed ${selectedInvoice.quantityLeft} kg`,
                        "error"
                      );
                      setOilseedWeight(null);
                      return;
                    }

                    setOilseedWeight(enteredWeight);
                  }}
                  placeholder="Enter weight"
                  mode="decimal"
                  minFractionDigits={2}
                  step={0.01}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("description")}
                />
              </div>
              <div className=" col-12 md:col-6">
                <label className="label-semi-bold">
                  Moisture (%)<span className="required">*</span>
                </label>
                <InputNumber
                  value={moistureContent}
                  onValueChange={(e) => setMoistureContent(e.value ?? null)}
                  mode="decimal"
                  step={0.01}
                  style={fieldHoverStyle("description")}
                  min={7}
                  max={10}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                />
              </div>
              <div className="field col-12 md:col-6">
                <label className="label-semi-bold">
                  Empty Container Weight (kg)<span className="required">*</span>
                </label>
                <InputNumber
                  value={emptyContainerWeight}
                  onValueChange={(e) =>
                    setEmptyContainerWeight(e.value ?? null)
                  }
                  mode="decimal"
                  step={0.01}
                  minFractionDigits={2}
                  style={fieldHoverStyle("description")}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default OilProductionDataTable1;
